import React, { Component } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import { URL_Click } from "../NonVisual/HLUtil";
import IntroChevron from "../../../img/IntroChevron.png";
import HLIntroBanner from "../Other/HLIntroBanner";
import Link from "@material-ui/core/Link";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";

class HLIntroForm extends Component {
    static propTypes = {
        left: PropTypes.number,
        onPageChange: PropTypes.func,
        sideBarOpen: PropTypes.bool,
        screenSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    };

    static defaultProps = {
        left: 0,
        onPageChange: () => console.log("onPageChange"),
        sideBarOpen: false,
        screenSize: 0,
    };

    state = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        const IntroChevronImg = (
            <img
                style={{
                    width: "100%",
                }}
                src={IntroChevron}
                alt="IntroChevron"
            />
        );

        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                        ...Theme.pageHeadingWithBannerStyle,
                    }}
                >
                    {HLConst.introAreaText}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p
                    style={{
                        color: Theme.HL_SecondaryColor,
                        ...Theme.labelFontStyle,
                        fontSize: 18,
                    }}
                >
                    Background
                </p>

                <p>
                    Effectiveness of interventions and their cost-effectiveness in humanitarian settings are important
                    given the increasing number, magnitude and complexity of emergencies combined with scarce and
                    precious funding. Until recently, guidance on which humanitarian interventions can save the largest
                    number of persons’ lives at the most effective cost by level of resources available did not exist.
                </p>

                <p
                    style={{
                        color: Theme.HL_SecondaryColor,
                        ...Theme.labelFontStyle,
                        fontSize: 18,
                    }}
                >
                    What is the H-LiST approach?
                </p>

                <p>
                    The Humanitarian Lives Saved Tool (H-LiST) approach is an evidence-based, step-by-step process
                    developed for use in humanitarian settings to provide recommendations on which maternal and child
                    health, nutrition and water, sanitation and hygiene (WASH) interventions, at specified coverage
                    levels, can save the most maternal and child lives. The approach also includes guidance on costing
                    activities to achieve the specified intervention coverage levels.
                </p>

                <p>
                    H-LiST is powered by the&nbsp;
                    <Link
                        onClick={() => URL_Click(HLConst.LiST_URL)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        Lives Saved Tool (LiST)
                    </Link>
                    , with some adjustments to contextualize results to humanitarian settings. LiST is a multi-cause
                    model of mortality that estimates the impact of scaling key maternal, newborn, child health (MNCH),
                    nutrition and WASH interventions in low- and middle-income countries (LMICs). LiST was developed by
                    the Institute for International Programs at JHSPH and is funded by the&nbsp;
                    <Link
                        onClick={() => URL_Click(HLConst.Gates_URL)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        Bill & Melinda Gates Foundation
                    </Link>
                    .
                </p>

                <p>The H-LiST approach guides humanitarian actors through a seven-step process of:</p>

                <ul>
                    <li>
                        Identifying which MNCH, nutrition and WASH interventions can save the most lives in a particular
                        context, given current coverage levels
                    </li>
                    <li>Brainstorming specific activities to increase coverage of those interventions</li>
                    <li>Estimating the incremental cost of those interventions</li>
                    <li>Choosing priority interventions for scale-up given cost and feasibility</li>
                </ul>

                {IntroChevronImg}

                {/*<p>*/}
                {/*H-LiST was developed by the Center for Humanitarian Health at Johns Hopkins University, in*/}
                {/*collaboration with the Lives Saved Tool (LiST) team and UNHCR. It is supported by the*/}
                {/*Bill & Melinda Gates Foundation.*/}
                {/*</p>*/}

                {/*<p*/}
                {/*style = {{*/}
                {/*color          : Theme.HL_SecondaryColor,*/}
                {/*...Theme.labelFontStyle,*/}
                {/*fontSize       : 18,*/}
                {/*}}*/}
                {/*>*/}
                {/*Who can use H-LiST and for what purposes?*/}
                {/*</p>*/}

                {/*<p>*/}
                {/*The H-LiST approach is for anyone interested in the efficient use of financial resources to save*/}
                {/*the most lives in humanitarian settings – including coordinating agencies, implementing partners*/}
                {/*and donors. It can be used for both planning as well as for advocacy purposes.*/}
                {/*</p>*/}

                <p
                    style={{
                        color: Theme.HL_SecondaryColor,
                        ...Theme.labelFontStyle,
                        fontSize: 18,
                    }}
                >
                    Scope
                </p>

                <p>
                    H-LiST is an approach to prioritizing MNCH, nutrition and WASH interventions based on which save the
                    most maternal and child lives (compared to other included interventions). It is a methodology for
                    identifying which activities can help you achieve increases in coverage in your LMIC setting in
                    order to save the most maternal and child lives as well as a process to identify which additional
                    resources you need in order to implement the activities you have identified.
                </p>

                <p>The H-LiST approach is NOT intended to:</p>

                <ul>
                    <li>Allocate funding between MNCH and other health/non-health areas</li>
                    <li>Justify stopping the provision of certain interventions</li>
                    <li>Estimate the total cost of a service delivery package</li>
                    <li>Calculate the total number of lives saved in your specific humanitarian setting</li>
                    <li>Measure the impact of interventions on morbidity or quality of life</li>
                    <li>Be applied in high-income settings</li>
                </ul>

                {/*<p*/}
                {/*style = {{*/}
                {/*color          : Theme.HL_SecondaryColor,*/}
                {/*...Theme.labelFontStyle,*/}
                {/*fontSize       : 18,*/}
                {/*}}*/}
                {/*>*/}
                {/*Included interventions*/}
                {/*</p>*/}

                {/*<p>*/}
                {/*For a list of the included MNCH, nutrition and WASH interventions, please see*/}

                {/*&nbsp;*/}

                {/*<Link*/}
                {/*onClick   = {() => {this.onPageChange(HLConst.step2Form)}}*/}
                {/*style     = {{*/}
                {/*cursor  : "pointer",*/}
                {/*}}*/}
                {/*underline = {"hover"}*/}
                {/*>*/}
                {/*Step 2*/}
                {/*</Link>*/}
                {/*.*/}
                {/*</p>*/}

                <p
                    style={{
                        color: Theme.HL_SecondaryColor,
                        ...Theme.labelFontStyle,
                        fontSize: 18,
                    }}
                >
                    Uses
                </p>

                <p>
                    The H-LiST approach is designed to be used in humanitarian settings – both acute and protracted – in
                    LMIC settings. Development work on the H-LiST approach was undertaken in Kenya and Uganda with&nbsp;
                    <Link
                        onClick={() => URL_Click(HLConst.UNHCR_URL)}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        UNHCR
                    </Link>
                    &nbsp;and partners in 2018 and 2019.
                </p>

                {/*<p*/}
                {/*style = {{*/}
                {/*color          : Theme.HL_SecondaryColor,*/}
                {/*...Theme.labelFontStyle,*/}
                {/*fontSize       : 18,*/}
                {/*}}*/}
                {/*>*/}
                {/*For more information or clarifications*/}
                {/*</p>*/}

                {/*<p>*/}
                {/*Email inquiries should be directed to*/}

                {/*&nbsp;*/}

                {/*<Link*/}
                {/*href    = {"mailto:humanithealth@jhu.edu"}*/}
                {/*style   = {{*/}
                {/*cursor  : "pointer",*/}
                {/*}}*/}
                {/*underline = {"hover"}*/}
                {/*>*/}
                {/*humanithealth@jhu.edu*/}
                {/*</Link>*/}
                {/*.*/}
                {/*</p>*/}
            </div>
        );

        return textDiv;
    };

    render() {
        const props = this.props;
        const left = props.left;
        const sideBarOpen = props.sideBarOpen;
        const screenSize = props.screenSize;

        const navBtnDiv = (
            <HLNavBtnDiv
                // onBackBtnClick = {() => this.onPageChange(HLConst.welcomeForm)}
                onNextBtnClick={() => this.onPageChange(HLConst.stepByStepForm)}
                showBackBtn={false}
            />
        );

        const introBanner = <HLIntroBanner left={left} screenSize={screenSize} sideBarOpen={sideBarOpen} />;

        return (
            <div>
                {introBanner}
                {this.renderTextDiv()}
                {navBtnDiv}
            </div>
        );
    }
}

export default HLIntroForm;
